<script>import { melt } from "@melt-ui/svelte";
import { getCtx, getAttrs } from "../ctx.js";
import { createDispatcher } from "../../../internal/events.js";
export let asChild = false;
const {
  elements: { thumb }
} = getCtx();
const dispatch = createDispatcher();
const attrs = getAttrs("thumb");
$:
  builder = $thumb();
$:
  Object.assign(builder, attrs);
</script>

{#if asChild}
	<slot {builder} />
{:else}
	<span {...builder} use:builder.action {...$$restProps} on:m-keydown={dispatch} />
{/if}
